module.exports = __webpack_public_path__ + "img/a333@2x.97a833ee.png";